import { CustomText } from '@/components/CustomText';
import { StyleSheet, View } from 'react-native';
import React, { useContext, useState } from 'react';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import { RelativePathString, useRouter } from 'expo-router';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import * as AppUtils from "@/utilities/AppUtils";
import * as AppConsts from "@/utilities/AppConsts";
import { UNKNOWN_COMMUNITY_MEMBERSHIP } from '@/types/community_membership';
import { RabblLink } from "@/components/RabblLink";
import { UNKNOWN_COMMUNITY } from '@/types/community';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "90%",
    gap: 20,
    alignItems: 'center',
    alignSelf: 'center',
  },
  horizontal: {
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  padding10: {
    padding: 10,
  },
});

type Props = {
  home?: boolean,
  rabblHome?: boolean,
  divider?: boolean,
};

const Footer = ({
  home = true,
  rabblHome = false,
  divider = true
}: Props) => {
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const communityMembership = useSelector((state: RootState) => state.user.communityMembership);

  return (
    <View style={styles.container}>

      <View style={styles.padding10} />
      { divider && <CustomDivider fullWidth={true} /> }

      <View style={styles.horizontal}>
        {
          home && (
            <>
              <Link
                href={AppUtils.getHomeLink(loggedIn, isMainLogicalHost, communityMembership)}
              >
                <CustomText type='link'>Home</CustomText>
              </Link>
              <CustomText>&nbsp;| </CustomText>
            </>
          )
        }
        {
          rabblHome && (
            <>
              <RabblLink key={-1} community={UNKNOWN_COMMUNITY}>
                <CustomText type='link'>Rabbl Home</CustomText>
              </RabblLink>
              <CustomText>&nbsp;| </CustomText>
            </>
          )
        }
        <Link href="/faqs"><CustomText type='link'>FAQs</CustomText></Link>
        <CustomText>&nbsp;| </CustomText>
        <Link href="/contact"><CustomText type='link'>Contact Us</CustomText></Link>
        <CustomText>&nbsp;| </CustomText>
        <Link href="/policies"><CustomText type='link'>Policies</CustomText></Link>
        <CustomText>&nbsp;| </CustomText>
        <Link href="/diagnostics"><CustomText type='link'>Diagnostics</CustomText></Link>
      </View>
      
      <View style={styles.padding10} />
    </View>
  );
};

export default Footer;
